var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import toast from 'react-hot-toast';
export function useRedeemConfirmationModal(props) {
    const modal = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const onRedeem = () => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            yield props.onRedeem();
            modal.hide();
        }
        catch (err) {
            console.error(err);
            const message = err instanceof Error ? err.message : 'Cannot redeem reward, please try again';
            toast.error(message);
        }
        setIsLoading(false);
    });
    return {
        isLoading,
        onRedeem,
    };
}
